/// <reference path="../types/jsx.d.ts" />
/// <reference path="../types/providers.d.ts" />

import "core-js/stable";
import "regenerator-runtime/runtime";
import "js/crossword/html/vueComponents";
import { getPuzzleFromDate } from "js/crossword/fetchPuzzleData";
import { getYearsInfo } from "js/crossword/getYearsInfo";
import { applyCustomisationOptionsToViewSettings } from "js/crossword/getCustomisationOptions";
import { loadSettingsData } from "js/crossword/settingsData";
import { convertPuzzleDataToPuzzleState } from "js/crossword/convertPuzzleDataToPuzzleState";
import { Puzzle } from "js/crossword/Puzzle";
import { createGameScene } from "js/crossword/html/createGameScene";
import { FeedFormat, IPuzzleData } from "js/crossword/types";
import { Signal } from "framework/utils/Signal";
import { getConfigOverride } from "js/debug/sgConfigOverride";
import { trackPartner, trackGameFlow, GameFlowEvent } from "js/tracking/track";
import { isBrowserSupported } from "js/crossword/isBrowserSupported";

interface ICustomWindow extends Window {
  sdkHandler: any; // TODO: use better typing 
  sgSettings: any; // TODO: use better typing
}

declare const window: ICustomWindow;
declare const sgSdk: any;

export const onFreezeChanged: Signal<void> = new Signal();

let frozen = false;

export function isFrozen(): boolean {
  return frozen;
}

// if (isBrowserSupported()) {
  runGame();
// } else {
//   document.getElementById("nosupport")!.style.display = "block";
// }

function runGame(): void {
  let startPuzzleData: IPuzzleData | null = null;

  sgSdk.initialize(
    ["basic", "levelGame"],
    {
      id: 'crossword',
      build: '1.19.1',
      supportedLanguages: ["en", "de", "fr", "ja"],
      runGame: () => {
        const puzzleStateData = convertPuzzleDataToPuzzleState(startPuzzleData!);
        createGameScene(new Puzzle(puzzleStateData));
        trackPartner();
        trackGameFlow(GameFlowEvent.StartPuzzle);
      },
      goToLevel: () => { },
      freezeGame: () => {
        frozen = true;
        onFreezeChanged.dispatch();
        console.warn("freezeGame");
      },
      unfreezeGame: () => {
        frozen = false;
        onFreezeChanged.dispatch();
        console.warn("unfreezeGame");
      },
    },
    async (error, settings, sdkHandler) => {
      if (error) console.warn(error);

      //FeedFormat.LAROUSSE = no json
      //FeedFormat.GERMAN_ARROW_WORD = bad json or i don't know
      settings.config.crossword = getConfigOverride(FeedFormat.HEARST_MICRO);
    
      window.sgSettings = settings;
      window.sdkHandler = sdkHandler;

      applyCustomisationOptionsToViewSettings();
      startPuzzleData = await getPuzzleFromDate(window.sgSettings.config.crossword.startingDate);

      loadSettingsData();
      getYearsInfo();

      sdkHandler.trigger("loading.completed", {
        callback: (error, user) => {
          if (error) {
            console.warn(error);
          }
        },
      });
    },
  );
}
